import { createPopper } from '@popperjs/core';
import { showToast } from './notification_toast';
import { fetchAPI } from "packs/api";
require("packs/reactions");
function getuserDetails(userid, rep_type, for_id) {
  let url =  "/users/" + userid + '/user_actions'
  fetchAPI(url, "GET", {"rep_type": rep_type, "for_id": for_id}, "script").then(response => {
    // No action
  }).catch(error => {
    let tooltip = document.querySelector('.profile-tooltip');
    tooltip.removeAttribute('data-show');
    showToast(I18n.t("user_not_found"))
  });
}

function openProfileTooltip(post, user, rep_type, elementId = null) {
  let button = document.getElementById(elementId || post);
	let tooltip = document.querySelector('.profile-tooltip');
  let isMobile = window.innerWidth <= 480;

  // Track tooltip visibility
  let isTooltipVisible = false;

  // Clean up any existing backdrop
  let existingBackdrop = document.getElementById('profile-tooltip-backdrop');
  if (existingBackdrop) existingBackdrop.remove();

  if (isMobile) {
    // Mobile: show as bottom sheet with backdrop overlay
    // Inline styles override existing base CSS; Tailwind handles animation
    Object.assign(tooltip.style, {
      position: 'fixed', bottom: '0', left: '0', right: '0', top: 'auto',
      width: '100%', borderRadius: '16px 16px 0 0', display: 'block',
      maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
      zIndex: '101'
    });
    tooltip.classList.add('transition-transform', 'duration-300', 'ease-out', 'translate-y-full');

    const arrow = tooltip.querySelector('.profilearrow');
    if (arrow) arrow.style.display = 'none';

    let backdrop = document.createElement('div');
    backdrop.id = 'profile-tooltip-backdrop';
    backdrop.className = 'fixed inset-0 bg-black/50';
    backdrop.style.zIndex = '100';
    document.body.appendChild(backdrop);

    function mobileHide() {
      tooltip.classList.add('translate-y-full');
      tooltip.classList.remove('translate-y-0');
      isTooltipVisible = false;
      backdrop.remove();
      document.removeEventListener('click', onBackdropClick);
    }

    function onBackdropClick(event) {
      if (event.target === backdrop) mobileHide();
    }

    window.popperHide = mobileHide;
    document.getElementById("user-action-sheet").innerHTML = "";
    tooltip.id = 'tooltip_' + post;
    document.querySelectorAll(".lazyloaded").forEach(el => el.classList.add("crazpopup"));
    document.addEventListener('click', onBackdropClick);

    requestAnimationFrame(() => {
      tooltip.classList.remove('translate-y-full');
      tooltip.classList.add('translate-y-0');
      isTooltipVisible = true;
    });

    getuserDetails(user.toString(), rep_type, post.toString());
    return;
  }

	let popperInstance = createPopper(button, tooltip, {
		placement: 'right',
		strategy: 'fixed',
		trigger: 'click',
		closeOnDocumentClick: true,
		modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
      {
        name: 'preventOverflow',
        options: {
          boundary: 'viewport',
          padding: 8,
        },
      },
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['left', 'bottom', 'top'],
        },
      },
    ],
	});

  function popperShow() {
		// Make the tooltip visible
		tooltip.setAttribute('data-show', '');
		tooltip.id = ('tooltip_' + post);
    document.querySelectorAll(".lazyloaded").forEach(el => el.classList.add("crazpopup"));
		// Enable the event listeners
		popperInstance.setOptions({
			modifiers: [{
				name: 'eventListeners',
				enabled: true
			}],
		});

		// Update its position
    // Ensure tooltip appears properly
     tooltip.style.display = "none";
     setTimeout(() => {
       tooltip.style.display = "block";
       isTooltipVisible = true;
       popperInstance.update();
     }, 50);
	}

	function popperHide() {
		// Hide the tooltip
		tooltip.removeAttribute('data-show');
    tooltip.style.display = "none"; // Hide tooltip
    isTooltipVisible = false; // Reset visibility flag

		// Disable the event listeners
		popperInstance.setOptions({
			modifiers: [{
				name: 'eventListeners',
				enabled: false
			}],
		});
    document.removeEventListener('click', onClickOutside);
	}

  document.removeEventListener('click', onClickOutside);
  document.addEventListener('click', onClickOutside);

  function onClickOutside(event) {
    if (isTooltipVisible && !tooltip.contains(event.target) && !button.contains(event.target) && !document.getElementById(`${post}_link`).contains(event.target)) {
      popperHide();
    }
  }

  window.popperHide = popperHide;
  document.getElementById("user-action-sheet").innerHTML = "";
	popperShow();
  getuserDetails(user.toString(), rep_type, post.toString());
}

window.openProfileTooltip = openProfileTooltip;

function userProfileActionEvents() {
    const textarea = document.getElementById('modal_textarea');
    const charCount = document.getElementById('char_count');
    const targetElModal = document.getElementById("modal_popup");
  
    const optionsModal = {
      backdrop: 'dynamic',
      backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
      closable: true,
    };

    const instanceOptionsModal = {
      id: 'modalEl',
      override: true
    };
  
    function setupModalButton(btnId, title, message, btnText, actionType, showTitle = true) {
      const btn = document.getElementById(btnId);
      if (btn) {
        btn.addEventListener("click", () => {
          showModal(title, message, btnText, actionType, showTitle);
          document.getElementById("modal_textarea").value = "";
        });
      }
    }
    setupModalButton("addnotebtn", I18n.t('add_note'), I18n.t('your_notes'), I18n.t('save'), "add_note");
    setupModalButton("alertexpiredbtn", I18n.t("think_topic_expired"), `${I18n.t("expired_deal_alert")}?`, I18n.t("send"), "alertexpired", false);
    setupModalButton("alertactivebtn", I18n.t("think_topic_active"), `${I18n.t("active_deal_alert")}`, I18n.t("send"), "alertactive", false);
    setupModalButton("complainbtn", I18n.t('complain'), I18n.t('add_complain'), I18n.t('send_alert'), "complain");
    let alertadminpost = document.querySelectorAll(".alertpostbtn");
    if (alertadminpost) {
      alertadminpost.forEach(btn => {
        btn.addEventListener("click", () => {
          showModal(I18n.t('complain'), I18n.t('add_complain'), I18n.t('send_alert'),  "alert_post", true, "", btn.dataset.postId);
        });
      })
    }
  
    const cancelModalBtn = document.getElementById('cancel_modalbtn');
    if (cancelModalBtn) {
      cancelModalBtn.addEventListener('click', function(event) {
        const modalInstance = new Modal(targetElModal, optionsModal, instanceOptionsModal);
        modalInstance.hide();
      });
    }
  
    const closeModalBtn = document.getElementById("close_modalbtn");
    if (closeModalBtn) {
      closeModalBtn.addEventListener("click", () => {
        const modal = new Modal(targetElModal, optionsModal, instanceOptionsModal);
        modal.hide();
      });
    }
  
    function showModal(title, description, submitText, action, showTextarea = true , link, postId) {
      const modalTitleElement = document.getElementById("modal_title");
      const modalDescriptionElement = document.getElementById("modal_description");
      const submitButtonElement = document.getElementById("submit_modalbtn");
      const modalTextareaElement = document.getElementById("modal_textarea");
  
      modalTitleElement.innerText = title;
      if (description.length > 0) {
        modalDescriptionElement.innerHTML = description;
      } else {
        modalDescriptionElement.style.display = "none";
      }
      submitButtonElement.innerText = submitText;
      modalTextareaElement.dataset.action = action;
      submitButtonElement.dataset.postId = postId;
  
      if (showTextarea) {
        modalTextareaElement.style.display = "block";
        modalTextareaElement.addEventListener('input', handleTextareaInput);
        modalTextareaElement.dispatchEvent(new Event('input'));
      } else {
        modalTextareaElement.style.display = "none";
        modalTextareaElement.removeEventListener('input', handleTextareaInput);
        charCount.textContent = "";
      }
  
      let optionsModalNew;
      if(link){
        optionsModalNew = {
          backdrop: 'dynamic',
          backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
          closable: true,
  
          onHide: () => {},
          onShow: () => {
            document.getElementById('cancel_modalbtn').style.display = 'none';
            submitButtonElement.classList.remove('py-2' , 'px-6');
            submitButtonElement.innerHTML = link;
          },
        }
      }
      else{
        optionsModalNew = optionsModal;
      }
  
      const modalInstance = new Modal(targetElModal, optionsModalNew, instanceOptionsModal);
      modalInstance.show();
    }
  
    const submitModalBtn = document.getElementById("submit_modalbtn");
  
    if (submitModalBtn) {
      submitModalBtn.addEventListener("click", (event) => {
        let commentId = submitModalBtn.dataset.postId;
        const getValue = (id) => {
          const element = document.getElementById(id);
          return element ? element.value : null;
        };
  
        const noteContent = document.getElementById("modal_textarea").value;
        const userId = getValue("current_user_id");
        const postTopicId = getValue("topic_id_" + commentId);
        const topicId = getValue("topic_id");
        const postId = getValue("post_id_" + commentId);
        const objectId = getValue("object_id");
        const objectType = getValue("object_type");
        const action = document.getElementById("modal_textarea").dataset.action;
  
      if (action === "add_note" || action === "complain" || action === "alert_post") {
        if (noteContent === '') {
          event.preventDefault();
          alert('Text cannot be blank.');
          return;
        }
      }
      
      if (action === "add_note") {
        fetch("/notes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
          },
          body: JSON.stringify({
            note: {
              note: noteContent,
              user_id: userId,
              object_id: objectId,
              object_type: objectType
            }
          })
        })
        .then(response => response.json())
        .then(data => {
            const confirmationMessage = `
                ${I18n.t('note_added_successfully')}
            `;
            let link = `<a href="/admin/object_log/${objectId}" target="_blank" class="inline-block w-full h-full px-6 py-2"> ${I18n.t('view_notes')}</a>`
            showModal(I18n.t('success'), confirmationMessage, I18n.t('okay_text'), "success", false , link);
            document.getElementById("submit_modalbtn").addEventListener("click", () => {
              let parser = new DOMParser();
              let doc = parser.parseFromString(link, 'text/html');
              let url = doc.querySelector('a').href;
              window.open(url, '_blank');
              window.location.reload();
            });
        })
        .catch(error => {
          console.error("Error:", error);
        });
      } else if (action === "complain") {
        fetch("/mod_alerts/create_alert", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
          },
          body: JSON.stringify({
            note: noteContent,
            user_id: userId,
            topic_id: topicId
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            showToast(`${I18n.t('complain_message')}`)
          } else {
            showToast(`${I18n.t('okay_text')}`);
          }
        })
        .catch(error => {
          console.error("Error:", error);
        });
      } else if (action === "alert_post") {
        fetch("/mod_alerts/create_alert", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
          },
          body: JSON.stringify({
            note: noteContent,
            user_id: userId,
            topic_id: postTopicId,
            post_id: postId
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            showToast(`${I18n.t('complain_message')}`)
          } else {
            showToast(`${I18n.t('okay_text')}`);
          }
        })
        .catch(error => {
          console.error("Error:", error);
        });
      } else if (action === "alertexpired") {
        fetch("/mod_alerts/create_alert", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
          },
          body: JSON.stringify({
            note: 'Deal Expired',
            user_id: userId,
            topic_id: topicId
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            showToast(`${I18n.t('complain_message')}`)
          } else {
            showToast(`${I18n.t('okay_text')}`);
          }
        })
        .catch(error => {
          console.error("Error:", error);
        });
      } else if (action === "alertactive") {
        fetch("/mod_alerts/create_alert", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
          },
          body: JSON.stringify({
            note: 'Deal Active',
            user_id: userId,
            topic_id: topicId
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            showToast(`${I18n.t('complain_message')}`)
          } else {
            showToast(`${I18n.t('okay_text')}`);
          }
        })
        .catch(error => {
          console.error("Error:", error);
        });
      }
  
        const modal = new Modal(targetElModal, optionsModal, instanceOptionsModal);
        modal.hide();
      });
    }
  
    function handleTextareaInput() {
      const remaining = 500 - textarea.value.length;
      charCount.textContent = ` ${I18n.t('characters_remaining')}: ${remaining}`;
      if (textarea.value.trim() === "") {
        charCount.textContent += ` ${I18n.t('this_field_is_required')}`;
      }
    }
  
    if (textarea) {
      textarea.addEventListener('input', handleTextareaInput);
      textarea.dispatchEvent(new Event('input'));
    }
}

window.userProfileActionEvents = userProfileActionEvents;

document.addEventListener("DOMContentLoaded", function () {
  let moredetailicons = document.querySelectorAll(".moredetailicon");
  let popupMenumoreDetailsdrops = document.querySelectorAll(
    ".popupMenumoreDetailsdrop"
  );
  moredetailicons.forEach((moredetailicon, index) => {
    moredetailicon.addEventListener("click", () => {
      popupMenumoreDetailsdrops[index].classList.toggle("hidden");
    });
  });
  document.addEventListener("click", (event) => {
    popupMenumoreDetailsdrops.forEach((popupMenumoreDetailsdrop, index) => {
      if (!popupMenumoreDetailsdrop.classList.contains("hidden")) {
        if (
          !popupMenumoreDetailsdrop.contains(event.target) &&
          !moredetailicons[index].contains(event.target)
        ) {
          popupMenumoreDetailsdrop.classList.add("hidden");
        }
      }
    });
  });

  if (document.getElementById("search-section")) {
    document
      .getElementById("search-section")
      .addEventListener("click", (event) => {
        if (event.target === document.getElementById("search-section")) {
          document.getElementById("comment-search").focus();
        }
      });
  }

  let bookmark_topic_tab = document.getElementById("bookmark_topic");
  let bookmark_comment = document.getElementById("bookmark_comment");

  function handleTabClick(activeTab, inactiveTab) {
    // Ensure smooth transition styles
    [activeTab, inactiveTab].forEach(tab => {
      if (tab) tab.style.transition = 'background-color 0.12s ease, color 0.12s ease';
    });

    inactiveTab.classList.remove('active');
    inactiveTab.classList.remove('bg-primary');
    inactiveTab.classList.remove('text-white');

    activeTab.classList.add('active');
    activeTab.classList.add('bg-primary');
    activeTab.classList.add('text-white');
  }

  if(bookmark_topic_tab){
    bookmark_topic_tab.addEventListener('click', function() {
      handleTabClick(bookmark_topic_tab, bookmark_comment);
    });
  }
 
  if(bookmark_comment){
    bookmark_comment.addEventListener('click', function() {
      handleTabClick(bookmark_comment, bookmark_topic_tab);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("ajax:success", function (event) {
      const button = event.target.closest("#follow-button");
      if (!button) return; // Ensure only #follow-button is handled

      const action = button.dataset.action;
      const userId = button.dataset.userId;

      if (action === "follow") {
          button.textContent = I18n.t("unfollow");
          button.dataset.action = "unfollow";
          showToast(I18n.t("successfully_followed"));
          button.setAttribute("href", Routes.become_fan_users_path({ fan_id: userId, remove: 1 }));
      } else {
          button.textContent = I18n.t("follow");
          button.dataset.action = "follow";
          showToast(I18n.t("successfully_unfollowed"));
          button.setAttribute("href", Routes.become_fan_users_path({ fan_id: userId }));
      }
  });

  document.addEventListener("ajax:error", function (event) {
      if (event.target.closest("#follow-button")) {
          alert("Something went wrong. Please try again.");
      }
  });
});